import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PreferencesProvider } from './context/PreferencesContext';
import { ThemeProvider } from './components/ui/ThemeProvider';

// 🆕 New import
import MerchantSummaryPage from './pages/transactions/MerchantSummaryPage';

// Layouts
import AppLayout from './components/layout/AppLayout';

// Pages
import Home from './pages/home/Home';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import Dashboard from './pages/dashboard/Dashboard';
import Accounts from './pages/accounts/Accounts';
import Transactions from './pages/transactions/Transactions';
import Reports from './pages/reports/Reports';
import Settings from './pages/settings/Settings';
import SubscriptionPlans from './pages/subscription/SubscriptionPlans';
import SubscriptionsBills from './pages/accounts/SubscriptionsBills';
import AccountDetailPage from './pages/accounts/AccountDetailPage';

// Components
import AIChatWidget from './components/chat/AIChatWidget';

function App() {
  return (
    <ThemeProvider defaultTheme="light">
      <AuthProvider>
        <PreferencesProvider>
          <Router>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

              {/* Subscription Route */}
              <Route path="/subscription" element={<SubscriptionPlans />} />

              {/* Protected Routes */}
              <Route element={<AppLayout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/accounts/:accountId/details" element={<AccountDetailPage />} />
                <Route path="/accounts/subscriptions-bills" element={<SubscriptionsBills />} />
                <Route path="/transactions" element={<Transactions />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/transactions/merchant-summary/:merchantName" element={<MerchantSummaryPage />} />
              </Route>
            </Routes>
            <AIChatWidget />
          </Router>
        </PreferencesProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
